import { atom } from 'recoil';

export const authTokenState = atom<string>({
  key: 'authTokenState',
  default: ''
});

export const cognitoIdState = atom<string>({
  key: 'cognitoIdState',
  default: '',
});

export const authLoadingState = atom<boolean>({
  key: 'authLoadingState',
  default: true,
});
